import { Component } from "@angular/core";

@Component({
    selector: "avatar-storybook",
    templateUrl: "./avatar-storybook.component.html",
})
export class AvatarStorybookComponent {
    shapes = ["circle", "square", "rounded"] as const;

    sizes = ["xl", "lg", "md", "sm", "xs"] as const;

    statuses = ["online", "offline"] as const;

    imageUrl = "/assets/images/avatars/Christy.jpg";

    userName = "JD";
}
